import MqttClient from "@/domain/core/utils/mqttClient";

const topics = {
    UPLOAD: '*/*/uploads/{picaServiceId}',
}

class MessageManager
{

    constructor() {
        this.client = MqttClient
        this.topic = null
        this._resetCb()
        this._resetMemory()
        this.connected = false
    }

    _onConnectionSuccess() {
        this.connected = true
        this._manageConnections()
    }

    _manageConnections() {
        // No callback, no need to do anything
        if (!this.hasCallbacks()) {
            // console.log('mqtt - no callbacks')
            // if it's connected, we should disconnect
            if (this.connected && this.topic)
                this.client.unsubscribe(this.topic)
            return
        }
        if (!this.topic) {
            // console.log('mqtt - no topic')
            return
        }

        if (!this.client.isInitialized()) {
            // console.log('mqtt - not initialized')
            this.client.init(this._onConnectionSuccess.bind(this))
            return
        }

        if (!this.connected) {
            // console.log('mqtt - not connected')
            return
        }

        // console.log('mqtt - subcribing to topic + '+this.topic)
        this.client.subscribe(this.topic, this._onNewMessage.bind(this))
    }


    _subscribeToTopic(topic) {
        if (this.topic && topic !== this.topic && this.connected) {
            this.client.unsubscribe(this.topic)
            this._resetCb()
            this._resetMemory()
        }

        this.topic = topic
        this._manageConnections()
    }

    _onNewMessage(message) {
        const payload = JSON.parse(message.payloadString)
        let metrics = payload.data.metrics
        if (metrics) {
            if (metrics.media_recognized_total) {
                let processed = parseInt(metrics.media_recognized_total)
                if (!this._isDifferent('processed', processed)) return
                this._cb('processed', processed)
            }
            if (metrics.media_uploaded_total) {
                let uploaded = parseInt(metrics.media_uploaded_total)
                if (!this._isDifferent('uploaded', uploaded)) return
                this._cb('uploaded', uploaded)
            }
        }
    }

    _isDifferent(type, newValue) {
        if (this.memory[type] === null) {
            this.memory[type] = newValue
            return true
        } else if (this.memory[type] !== newValue) {
            this.memory[type] = newValue
            return true
        }
        return false
    }

    _cb(type, value) {
        this.cb[type].forEach(cb => cb.cb(value))
    }

    _resetCb() {
        this.cb = {
            uploaded: [],
            processed: []
        }
    }

    _disconnect() {
        if (!this.topic) return

        this.client.unsubscribe(this.topic)
        this._resetCb()
        this._resetMemory()
    }

    _resetMemory() {
        this.memory = {
            uploaded: null,
            processed: null
        }
    }

    setUserId(userId) {
        this.client.setUserId(userId)
    }

    setPicaService(picaServiceId)
    {
        if (picaServiceId === null) {
            this._disconnect()
            return
        }
        const topic = topics.UPLOAD.replace('{picaServiceId}', picaServiceId)
        this._subscribeToTopic(topic)
    }

    onUploaded(key, cb) {
        this.cb.uploaded.push({key: key, cb: cb})
        this._manageConnections()
    }

    onProcessed(key, cb) {
        this.cb.processed.push({key: key, cb: cb})
        this._manageConnections()
    }

    hasCallbacks() {
        return this.cb.uploaded.length > 0
            || this.cb.processed.length > 0
    }

    removeCallbacks(key) {
        this.cb.uploaded = this.cb.uploaded.filter(cb => cb.key !== key)
        this.cb.processed = this.cb.uploaded.filter(cb => cb.key !== key)
        this._manageConnections()
    }
}

export default new MessageManager()